import { z } from "zod";
export const GetPropensityResponse = z.record(z.string(), z.unknown());
//# sourceMappingURL=diagnostics.js.map